import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Th, Thead, Tr, useToken } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';
import { getColumnStyleAndProps } from '../utils';
import { HeadCellFooter } from './HeadCellFooter';
import { SortingIcon } from './SortingIcon';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var headerAlignProps = {
  left: {
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  center: {
    justifyContent: 'center',
    flexDirection: 'row'
  },
  right: {
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
  }
};
export var TableHeader = function TableHeader(_ref) {
  var isDisabled = _ref.isDisabled;
  var dockedZIndex = useToken('zIndices', 'docked');

  var _useTableContext = useTableContext(),
      table = _useTableContext.table;

  return /*#__PURE__*/_jsx(Thead, {
    zIndex: dockedZIndex + 1,
    pos: "sticky",
    top: "0",
    e2eid: "CrudTable_TableHeader_Thead",
    children: table.getHeaderGroups().map(function (headerGroup) {
      return /*#__PURE__*/_jsx(Tr, {
        e2eid: "CrudTable_TableHeader_Tr",
        children: headerGroup.headers.map(function (header) {
          var _header$column$column;

          var canSort = header.column.getCanSort();
          var align = (_header$column$column = header.column.columnDef.align) !== null && _header$column$column !== void 0 ? _header$column$column : 'left';
          return /*#__PURE__*/_jsx(Th, _objectSpread(_objectSpread({
            colSpan: header.colSpan,
            px: 2,
            py: 1.5,
            textTransform: "none"
          }, getColumnStyleAndProps(header.column, true)), {}, {
            e2eid: "CrudTable_TableHeader_Th",
            children: /*#__PURE__*/_jsxs(Box, {
              display: "flex",
              flexDir: "column",
              rowGap: 1,
              justifyContent: "space-between",
              e2eid: "CrudTable_TableHeader_Box",
              children: [/*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
                display: "flex",
                alignItems: "center",
                columnGap: 1,
                cursor: canSort && !isDisabled ? 'pointer' : 'auto',
                onClick: header.column.getToggleSortingHandler()
              }, align ? headerAlignProps[align] : {}), {}, {
                e2eid: "CrudTable_TableHeader_Box_4",
                children: [header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext()), /*#__PURE__*/_jsx(SortingIcon, {
                  column: header.column,
                  e2eid: "CrudTable_TableHeader_SortingIcon"
                })]
              })), /*#__PURE__*/_jsx(HeadCellFooter, {
                column: header.column,
                isDisabled: isDisabled,
                e2eid: "CrudTable_TableHeader_HeadCellFooter"
              })]
            })
          }), header.id);
        })
      }, headerGroup.id);
    })
  });
};